module.exports = __webpack_public_path__ + "img/banking.420e528.png";